module.exports = __webpack_public_path__ + "static/klapna-8ce526d813da66abb539a32c620baee0.jpg";